import {QueryClient, useQuery, UseQueryResult} from "@tanstack/react-query";
import {useRef} from "react";
import {StereotypeApiClient} from "../../../../common/apis/stereotype/StereotypeApiClient";
import {StereotypeDto} from "../../../../common/apis/stereotype/StereotypeDto";

export function useFindAllStereotypesQuery(): UseQueryResult<StereotypeDto[], any> {
    const stereotypeApiClient = useRef(new StereotypeApiClient());

    return useQuery({
        queryKey: ["stereotypes.stereotypes"],
        queryFn: () => stereotypeApiClient.current.findAll(),
    });
}

export function invalidateFindAllStereotypesQueryCache(queryClient: QueryClient) {
    queryClient.invalidateQueries({
        queryKey: ["stereotypes.stereotypes"],
        exact: true
    });
}